import { ApiRequestOptions } from '@api/core/ApiRequestOptions';
import { getRequestOptions } from '@api/core/utils';

import type { AirportSearchViewModel } from '../models/AirportSearchViewModel';
import type { SearchUrlViewModel } from '../models/SearchUrlViewModel';
import type { SearchViewModel } from '../models/SearchViewModel';
import type { VehicleOfficeSearchViewModel } from '../models/VehicleOfficeSearchViewModel';
import type { CancelablePromise } from '../core/CancelablePromise';
import { request as __request } from '../core/request';

export class SearchesService {
  /**
   * @deprecated
   * Url
   * Searches all url by slug
   * @returns SearchUrlViewModel Success
   * @throws ApiError
   */
  public static async url(
    {
      slug,
    }: {
      slug: string;
    },
    options?: Partial<ApiRequestOptions>
  ): CancelablePromise<SearchUrlViewModel> {
    const { cookies = {}, headers = {} } = options ?? {};
    delete cookies.token;
    const result = await __request<SearchUrlViewModel>({
      method: 'GET',
      url: `/searches/url/${slug}`,
      path: {
        ...(slug ? { slug: slug } : {}),
      },
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
        500: `Server Error`,
      },
      headers: getRequestOptions(headers, 'headers'),
      cookies: { ...getRequestOptions(cookies, 'cookies') },
    });
    return result;
  }

  /**
   * Url
   * Searches for an url
   * @returns SearchViewModel Success
   * @throws ApiError
   */
  public static async searchesUrl(
    {
      s,
      webUrl,
    }: {
      /**
       * Search terms
       */
      s: string;
      /**
       * WebUrlType (Hotel,Tour,Cruise)
       */
      webUrl?: any;
    },
    options?: Partial<ApiRequestOptions>
  ): CancelablePromise<SearchViewModel> {
    const { cookies = {}, headers = {} } = options ?? {};
    delete cookies.token;
    const result = await __request<SearchViewModel>({
      method: 'GET',
      url: `/searches/url`,
      query: {
        ...(s ? { s: s } : {}),
        ...(webUrl ? { webUrl: webUrl } : {}),
      },
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
        500: `Server Error`,
      },
      headers: getRequestOptions(headers, 'headers'),
      cookies: { ...getRequestOptions(cookies, 'cookies') },
    });
    return result;
  }

  /**
   * Hotel
   * Searches all hotels
   * @returns SearchViewModel Success
   * @throws ApiError
   */
  public static async searchesHotel(
    {
      s,
      domestic,
    }: {
      /**
       * Search terms
       */
      s: string;
      /**
       * Domestic
       */
      domestic?: boolean;
    },
    options?: Partial<ApiRequestOptions>
  ): CancelablePromise<Array<SearchViewModel>> {
    const { cookies = {}, headers = {} } = options ?? {};
    delete cookies.token;
    const result = await __request<Array<SearchViewModel>>({
      method: 'GET',
      url: `/searches/hotel`,
      query: {
        ...(s ? { s: s } : {}),
        ...(domestic ? { domestic: domestic } : {}),
      },
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
        500: `Server Error`,
      },
      headers: getRequestOptions(headers, 'headers'),
      cookies: { ...getRequestOptions(cookies, 'cookies') },
    });
    return result;
  }

  /**
   * Tour
   * Searches all tours
   * @returns SearchViewModel Success
   * @throws ApiError
   */
  public static async searchesTour(
    {
      s,
    }: {
      /**
       * Search terms
       */
      s: string;
    },
    options?: Partial<ApiRequestOptions>
  ): CancelablePromise<Array<SearchViewModel>> {
    const { cookies = {}, headers = {} } = options ?? {};
    delete cookies.token;
    const result = await __request<Array<SearchViewModel>>({
      method: 'GET',
      url: `/searches/tour`,
      query: {
        ...(s ? { s: s } : {}),
      },
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
        500: `Server Error`,
      },
      headers: getRequestOptions(headers, 'headers'),
      cookies: { ...getRequestOptions(cookies, 'cookies') },
    });
    return result;
  }

  /**
   * Flight
   * Searches all flights
   * @returns AirportSearchViewModel Success
   * @throws ApiError
   */
  public static async searchesFlight(
    {
      s,
    }: {
      /**
       * Search terms
       */
      s: string;
    },
    options?: Partial<ApiRequestOptions>
  ): CancelablePromise<Array<AirportSearchViewModel>> {
    const { cookies = {}, headers = {} } = options ?? {};
    delete cookies.token;
    const result = await __request<Array<AirportSearchViewModel>>({
      method: 'GET',
      url: `/searches/flight`,
      query: {
        ...(s ? { s: s } : {}),
      },
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
        500: `Server Error`,
      },
      headers: getRequestOptions(headers, 'headers'),
      cookies: { ...getRequestOptions(cookies, 'cookies') },
    });
    return result;
  }

  /**
   * Vehicle
   * Searches all vehicles
   * @returns VehicleOfficeSearchViewModel Success
   * @throws ApiError
   */
  public static async searchVehicle(
    {
      s,
    }: {
      /**
       * Search terms
       */
      s: string;
    },
    options?: Partial<ApiRequestOptions>
  ): CancelablePromise<Array<VehicleOfficeSearchViewModel>> {
    const { cookies = {}, headers = {} } = options ?? {};
    delete cookies.token;
    const result = await __request<Array<VehicleOfficeSearchViewModel>>({
      method: 'GET',
      url: `/searches/vehicle`,
      query: {
        ...(s ? { s: s } : {}),
      },
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
        500: `Server Error`,
      },
      headers: getRequestOptions(headers, 'headers'),
      cookies: { ...getRequestOptions(cookies, 'cookies') },
    });
    return result;
  }
}
